import { useState, useEffect } from "react";
import { loadStorageLocationList, loadStorageLocationListByID, loadWarehouseList, loadWarehouseTypeList } from "../../services/warehouseService";

const useWarehouseStorageLocationListByID = (Mode) => {
    const [warehouseStorageLocationListByID, setWarehouseStorageLocationListByID] = useState([]);
    const [isWarehouseLocationDataLoaded, setIsWarehouseLocationDataLoaded] = useState(false);
   

    const fetchWarehouseStorageLocationListByID = async (row) => {
        const para = {
            p_warehouse_id: row.warehouse_id,
            p_bin_type_id: row.bin_type_id,
            p_location_type_id: row.location_type_id
        };

        try {
            const data = await loadStorageLocationListByID(para);
            if (data && data.length > 0) {
                setWarehouseStorageLocationListByID(data);
                setIsWarehouseLocationDataLoaded(true);
                // const initialWarehouse = data.find((dept) => dept.warehouse_location_id === selectedID);

                // if (initialWarehouse) { // ✅ Corrected check
                //     setSelectedWarehouseStorageLocation(initialWarehouse);
                //     setSelectedWarehouseStorageLocationID(initialWarehouse.warehouse_location_id);
                //     setIsWarehouseLocationDataLoaded(true);
                // }
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    // useEffect(() => {
    //     if (!isWarehouseLocationDataLoaded) {
    //         fetchWarehouseStorageLocationListByID();
    //     }
    // }, [isWarehouseLocationDataLoaded]);

    // Function to load department based on selected ID
    const loadWarehouseStorageLocationBySelectedID = async (row) => {
        await fetchWarehouseStorageLocationListByID(row);
    };


    return {
        warehouseStorageLocationListByID,      
        setWarehouseStorageLocationListByID,
        loadWarehouseStorageLocationBySelectedID,
    };
};

export default useWarehouseStorageLocationListByID;
